<template>
    <div class="template template--basic">

        <div class="login">

            <header class="login__header">
                <h1>Welkom terug!</h1>
                <p>Vul je e-mailadres en wachtwoord in om je werkmap te openen
                    <template v-if="otherLinks"><br>
                        <strong>Nog geen werkmap?</strong> Ga naar <router-link :to="{ name: 'register' }" class="to-register">registreren</router-link>
                    </template>
                </p>
            </header>

            <div class="login__panel-wrap">
                <div class="login__panel">

                    <form class="login__form">

                        <div class="input-group">
                            <label for="email">E-mail</label>
                            <input type="email" name="email" id="email" v-model="email" @keydown.enter.prevent="submit" :autofocus="!isTouch" />
                        </div>

                        <div class="input-group">
                            <label for="password">Wachtwoord</label>
                            <input type="password" name="password" id="password" v-model="password" @keyup.enter.prevent="submit" />
                        </div>

                        <div class="input-group">
                            <input type="checkbox" name="remember" id="remember" v-model="remember" />
                            <label for="remember">Blijf 30 dagen ingelogd</label>
                        </div>

                        <primary-button @clicked="submit" :loading="loading" >Inloggen</primary-button>

                    </form>

                </div>

                <div class="login__auth-other" v-if="otherLinks" :class="{ 'auth-attention': hasInvalidCredentials }">
                    <router-link :to="{ name: 'register' }" class="to-register">Registreren</router-link> |
                    <router-link :to="{ name: 'forgot' }" class="to-forgot-password">Wachtwoord vergeten</router-link>
                </div>
            </div>

        </div>


    </div>
</template>


<script>
import { login, checkAuthentication } from 'js/api/auth';
import notify from 'js/components/notifications/notificationsMixin';
import validation from 'js/components/auth/validationMixin';
import touch from 'js/components/auth/touchMixin';

import PrimaryButton from 'js/components/elements/PrimaryButton.vue';

export default {
    name: 'Login',
    mixins: [ notify, validation, touch ],
    components: { PrimaryButton },
    props: {
        otherLinks: {
            type: Boolean,
            default: true,
        },
    },
    data: function() {
        return {
            email: '',
            password: '',
            remember: true,
            loading: false,
            errors: [],
            errorFields: [],
            hasInvalidCredentials: false,
        }
    },
    beforeRouteEnter: (to, from, next) => {

        if ( to.query.account === 'demo' ) {

            login('demo@kiempunt.nl', 'demo')
                .then(() => next({ name: 'root', replace: true }) )
                .catch( () => next( vm => {
                    vm.$warn('Het demo account is op dit moment niet beschikbaar, probeer het later nog eens.')
                }))

        } else {
            // if user can authenticate => redirect immediately to dashboard
            checkAuthentication()
                .then( () => next({ name: 'root', replace: true }) )
                .catch( () => next())
        }


    },
    methods: {
        submit: function(e) {

            e.preventDefault();

            if ( this.validateFields() ) {

                this.loading = true

                login(this.email, this.password, this.remember)
                    .then( () => this.$router.push({ name: 'root' }) )
                    .catch( response => {
                        if ( response.status === 401 ) {
                            this.invalidCredentials()
                        } else {
                            this.handleErrorResponse(response, 'Inloggen is mislukt.')
                        }
                        return new Promise( resolve => {
                            setTimeout(resolve, 2000)
                        })

                    }).then( () => this.loading = false)

            } else {
                this.invalidCredentials()
            }

        },

        validateFields: function() {
            return this.validateEmail(this.email) && this.validatePasswordLength(this.password)
        },

        invalidCredentials: function() {
            this.$warn('Het ingevoerde e-mailadres of wachtwoord is onjuist.', { id: 'validation' })
            this.hasInvalidCredentials = true
            setTimeout(() => this.hasInvalidCredentials = false, 1500)
        }

    }

}
</script>


<style lang="scss">

    @import 'global';

</style>



// WEBPACK FOOTER //
// Login.vue?37379d4a